<template>
  <footer class="footer default-footer">
    <div
      class=""
      :class="
        $route.name === 'Auth' || $route.name === 'Registration'
          ? 'content_default'
          : 'content'
      "
    >
      <div class="dashboard__footer dashboard-footer">
        <div class="dashboard-footer__copyright">
          {{ $t('footer.copyright') }}
        </div>
        <a
          class="dashboard-footer__link"
          href="/download/privacy-policy.pdf"
          target="_blank"
        >
          {{ $t('footer.privacy') }}</a
        >
        <div
          class="dashboard-footer__rules"
          v-html="$t('footer.description')"
        ></div>
      </div>
    </div>
  </footer>
</template>

<script>
import { Trans } from '@/plugins/translation'
export default {
  name: 'SuccessFooter',
  computed: {
    currentLocale() {
      return Trans.currentLocale.trim()
    },
  },
}
</script>

<style scoped>
.dashboard-footer {
  padding-bottom: 30px;
  position: relative;
  z-index: 2;
}
.footer {
  margin-top: auto;
  padding-bottom: 0;
  background-color: transparent;
}

.footer .content {
  width: 100%;
}

.auth-footer .content {
  width: 1170px;
  padding: 0;
}

.dashboard-footer__copyright {
  margin-bottom: 15px;
  font-family: 'HelveticaNeue', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #808080;
}

.dashboard-footer__link {
  display: block;
  margin-bottom: 15px;
  font-family: 'HelveticaNeue', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
  color: #5c4c8b;
}

.dashboard-footer__rules {
  font-family: 'HelveticaNeue', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #808080;
}

.auth-footer {
  margin-top: 0;
  padding-bottom: 48px;
  background-color: #f8f8f8;
}
@media screen and (min-width: 1441px) {
  .auth-footer .content {
    width: 1440px;
    padding: 0;
  }
}

@media screen and (max-width: 1220px) {
  .footer .content {
    padding: 0;
  }

  .auth-footer .content {
    width: 100%;
    padding: 0 40px;
  }
}

@media screen and (max-width: 743px) {
  .dashboard-footer__rules {
    font-size: 15px;
    line-height: 24px;
  }

  .dashboard-footer__link {
    font-size: 15px;
    line-height: 24px;
  }

  .dashboard-footer__copyright {
    font-size: 15px;
    line-height: 24px;
  }

  .dashboard-footer {
    padding-bottom: 56px;
  }
  .content {
    padding: 0;
  }

  .dashboard-footer {
    padding: 30px 0 0;
  }
}
@media screen and (max-width: 1220px) and (min-width: 768px) {
  .content {
    padding: 0;
  }
  .dashboard-footer {
    padding-top: 30px;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
